import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_AppErrorField = _resolveComponent("AppErrorField")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "pb-0" }, "Recover Your Account", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("h4", null, "Enter your email, we send you a password reset link", -1)),
    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.form,
      rules: _ctx.rules
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { prop: "email" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
              placeholder: "Email",
              "prefix-icon": _ctx.Message
            }, null, 8, ["modelValue", "prefix-icon"])
          ]),
          _: 1
        }),
        _createVNode(_component_AppErrorField, { error: _ctx.errorMsg }, null, 8, ["error"]),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              class: "w-100",
              onClick: _ctx.forgotPassword
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" SEND REQUEST ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ], 64))
}